/**
 * Internal operator planning illustration - hypothetical only.
 * Shown ONLY at /internal/operator-plan; never embedded in buyer pages.
 */

export const operatorPlanContent = {
  warning:
    "For operator use only. Figures are illustrative planning math - not forecasts, commitments, tax advice, or accounting guidance.",

  revenueScenarios: {
    headline: "Illustrative project economics (hypothetical Year 1 exercise)",
    projects: [
      {
        label: "Conservative mixed pipeline",
        projectsPerMo: "5 engagements",
        averageTicket: "~$8,000 effective blended rate assumption",
        monthlyImplied: "~$40,000",
        yearlyImplied: "~$480,000",
      },
      {
        label: "Additive retainer mix (example)",
        description:
          "20 active clients @ roughly $800/mo average care blocks (SKU-style) - not capped labor pools.",
        monthlyImplied: "~$16,000",
        yearlyImplied: "~$192,000",
      },
    ],
  },

  expenses: [
    {
      category: "Labor (2–3 FTE equivalents)",
      amount: "~$180,000/yr illustrative fully loaded planning placeholder",
    },
    {
      category: "Software & tooling",
      amount: "~$24,000",
    },
    {
      category: "Marketing",
      amount: "~$30,000",
    },
    {
      category: "Overhead / facilities / misc",
      amount: "~$24,000",
    },
    {
      category: "Tax & compliance reserve (consult CPA)",
      amount: "~$72,000 illustrative planning bucket",
    },
  ],

  marginNote:
    "The prior scratch model suggested ~31% operating margin AFTER aggressive tax reserving - purely illustrative. Real margin depends on realization rates, pass-through BOM, rework, churn, utilization, geographic labor costs, and counsel/accounting structuring.",

  launchChecklist: [
    {
      title: "Legal setup",
      items: [
        "Form LLC or chosen entity via counsel-reviewed filing roadmap",
        "Evaluate C‑7 Low Voltage Licensing pathway ($500–$1,000+ fee ranges historically published - confirm current statutes)",
        "General liability / E&O / cyber coverage quotes ($2k–$4k/yr illustrative band - bind only after underwriting review)",
        "Bond thresholds if prevailing wage or municipality mandates trigger",
      ],
    },
    {
      title: "Technical infrastructure",
      items: [
        "Standardized dev tooling + secrets baseline (no keys in repos)",
        "LLM routing strategy - OpenAI, Anthropic, local inference cost envelope",
        "Cloud baseline (AWS / GCP / Azure) with infra-as-code stubs",
        "Template library version control for SOW numbering + placeholders",
      ],
    },
    {
      title: "Marketing & pipeline",
      items: [
        "Dogfood flagship site + instrumentation + embodied AI concierge proof",
        "LinkedIn outbound sequences per vertical playbook",
        "Local SEO citations + GBP hygiene",
        "Partner MOUs (MSPs, electricians, creatives)",
      ],
    },
    {
      title: "Operations",
      items: [
        "Contract template lifecycle + markdown → PDF toolchain",
        "Client onboarding questionnaires + network discovery packet",
        "Project management tooling + weekly executive snapshot",
        "Vendor matrix (hardware distributors, cabling partners)",
      ],
    },
  ],

  secrecy:
    "Do not link this page from footer, hero, Markets, Pricing, Contact, or outbound drip campaigns unless intentionally repositioning transparency - default remains bookmark-only.",

};
